/* eslint-disable import/prefer-default-export */
import { TranslationConfig } from 'react-utilities';
/**
 * Translations required by this web app (remember to also edit
 * `bundle.config.js` if changing this configuration).
 */
export const TRANSLATION_CONFIG: TranslationConfig = {
  common: ['CommonUI.Messages'],
  feature: 'Feature.SecurityQuestions'
};
